<script>
  import OverpanelControl from '../OverpanelControl/OverpanelControl.svelte';
  import BaseButton from '../BaseButton/BaseButton.svelte';
  import BaseDiv from '../BaseDiv/BaseDiv.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { overpanelMap, openOverpanel, closeOverpanel } from '../../stores/overpanelControl';
  import { drug, drugData } from '../../stores/drug';

  let {
    title,
    drugTypeLabel,
    formLabel,
    singleFormText,
    strengthLabel,
    quantityLabel,
    updateButtonText,
    dataTestId = 'drug-overpanel',
    closeCallback = () => {},
  } = $props();

  let buttons = $state([]);
  let slug = $state([]);

  drugData.subscribe((value) => {
    if (value.drug) {
      slug = value.drug.slug;

      buttons = [
        {
          testId: `${dataTestId}-type-button`,
          label: drugTypeLabel,
          text: value.drug.name,
          onClick: () => {
            openOverpanel('drugSelection');
          },
        },
        {
          testId: `${dataTestId}-form-button`,
          label: formLabel,
          text: value.form.value,
          subtext: value.drug.forms.length === 1 && singleFormText,
          disabled: value.drug.forms.length === 1,
          onClick: () => {
            openOverpanel('drugForm');
          },
        },
        {
          testId: `${dataTestId}-strength-button`,
          label: strengthLabel,
          text: value.strength.label,
          onClick: () => {
            openOverpanel('drugStrength');
          },
        },
        {
          testId: `${dataTestId}-quantity-button`,
          label: quantityLabel,
          text: value.quantity.label,
          onClick: () => {
            openOverpanel('drugQuantity');
          },
        },
      ];
    }
  });

  const handleUpdateClick = () => {
    window.umami.track('drug-overpanel-update', { drug: slug });
    
    closeOverpanel('drug');
  };
</script>

{#if $overpanelMap.has('drug') && $drug}
  <OverpanelControl {title} {closeCallback} overpanelKey="drug">
    <div class="flex flex-col bg-gray-mercury min-h-full" data-testid={dataTestId}>
      <div class="flex flex-col flex-1">
        {#each buttons as { label, text, subtext, disabled, onClick, testId }}
          {@const SvelteComponent = disabled ? BaseDiv : BaseButton}
          <SvelteComponent
            className={`flex flex-col bg-white text-blue-cerulean py-3 pl-4 pr-2 border-b border-gray-silver
            items-stretch focus:relative group ${
              !disabled
                ? 'hover:text-blue-darkish focus:relative focus:outline-none active:shadow-inset-active focus:shadow-inset-focus'
                : ''
            }`}
            {...disabled ? {} : { onClick }}
            dataTestId={testId}
          >
            <div class="flex flex-row items-center">
              <div class="flex-1 text-left">
                <div class="text-sm leading-tight text-gray-charcoal">{label}</div>
                <div
                  class="text-lg leading-normal font-medium"
                  class:group-hover:text-blue-darkish={!disabled}
                  class:group-hover:underline={!disabled}
                >
                  {text}
                </div>
              </div>
              {#if !disabled}
                <svg
                  class="w-8 h-8 fill-current flex-none hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish"
                >
                  <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
                </svg>
              {/if}
            </div>
            {#if subtext}
              <div class="text-sm text-left py-2 leading-normal text-blue-navy">{subtext}</div>
            {/if}
          </SvelteComponent>
        {/each}
      </div>
      <button
        class="leading-loose text-center font-medium bg-blue-robin-egg hover-hover:hover:bg-blue-light active:bg-blue-malibu
        focus:outline-none focus:shadow-inset-focus active:shadow-inset-active sm:rounded-md whitespace-nowrap min-w-25 px-8 flex
        items-center justify-center h-16 sm:h-12 mt-0.5 mx-auto sm:max-w-sm w-full sm:my-4"
        onclick={handleUpdateClick}
        data-testid={`${dataTestId}-update-button`}
      >
        {updateButtonText}
      </button>
    </div>
  </OverpanelControl>
{/if}
